import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {
  @Input() inputIframe: any
  @Input() symbol: any
  @Input() companyId: any
  @Input() dataType: any
  @Input() modalRef: BsModalRef
  @Output() getResponeUpload = new EventEmitter()
  @Output() paramUpdate = new EventEmitter()
  message = 'Invalid file type.'

  form: FormGroup
  file: File
  preview
  enable: boolean

  constructor(
    private cpmService: CpmService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.createForm()
    $('#fileButton').click(function () {
      $('#upload').click()
    })
    this.enable = false
  }

  createForm() {
    this.form = new FormGroup({
      file: new FormControl(this.file)
    })
  }

  fileChange(event: any) {
    const iframes = document.querySelectorAll('iframe')
    const reader = new FileReader()
    if (event.target.files && event.target.files.length > 0) {
      this.file = event.target.files[0]
      if (this.file && this.checkDataType()) {
        const fileType = this.file['name'].split('.')
        const openableFormat = ['jpg', 'png', 'svg', 'gif', 'jpeg']
        const openModalForType = (openableFormat.indexOf(fileType[fileType.length - 1].toLowerCase()) > -1)
        if (openModalForType) {
          this.enable = true;
          document.getElementById('previewDiv').style.display = 'block';
          document.getElementById('choosefileDiv').style.display = 'none';
          reader.addEventListener('load', function () {
            Array.from(iframes).forEach(iframe => {
              if (iframe.id === 'preview') {
                iframe.src = reader.result
              }
            })
          },
            false
          )
          if (this.file) {
            reader.readAsDataURL(this.file)
          }
        } else {
          this.toastr.error('Selected file is not a picture.')
        }
      } else {
        this.enable = true;
        document.getElementById('previewDiv').style.display = 'block';
        document.getElementById('choosefileDiv').style.display = 'none';
        reader.addEventListener('load', function () {
          Array.from(iframes).forEach(iframe => {
            if (iframe.id === 'preview') {
              iframe.src = reader.result
            }
          })
        },
          false
        )
        if (this.file) {
          reader.readAsDataURL(this.file)
        }
      }
    }
  }

  async upload() {
    const body = new FormData()
    body.append('file', this.file)
    body.append('type', this.dataType)
    body.append('id', this.companyId)
    await this.cpmService.uploadFile(body).then(response => {
      if (response.status === 'FAIL') {
        alert(response.message)
      } else {
        this.paramUpdate.emit(this.symbol)
        this.getResponeUpload.emit(true)
        this.modalRef.hide()
      }
    })
  }

  reupload() {
    $('#upload').click()
  }
  checkDataType() {
    if (this.dataType === 'Competitor' || this.dataType === 'Customer' || this.dataType === 'OtherInfo') {
      return true
    } else {
      return false
    }
  }
  last3Array(arr: any) {
    return arr.slice(Math.max(arr.length - 3, 1))
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/upload-file/upload-file.component.ts